import React from "react";
import { Plus, AlertCircle, Lock } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const WorkflowLimitButton = ({ 
  onClick, 
  currentCount = 5, 
  maxLimit = 10 
}) => {
  
    return (
      <motion.div
        className="relative"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        {/* Disabled Button */}
        <motion.button
          disabled
          className="flex items-center gap-2 px-4 py-2 
            bg-gradient-to-r from-gray-300 to-gray-400 
            text-gray-600 rounded-lg cursor-not-allowed 
            transition-all shadow-sm border border-gray-200
            relative overflow-hidden"
          whileHover={{
            scale: 1.02,
            boxShadow: "0 4px 12px -2px rgba(239, 68, 68, 0.2)"
          }}
        >
          {/* Animated Warning Background */}
          <motion.div
            className="absolute inset-0 bg-gradient-to-r from-red-100 to-orange-100"
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.7 }}
            transition={{ duration: 0.3 }}
          />

          {/* Content */}
          <div className="relative z-10 flex items-center gap-2">
            <motion.div
              animate={{ 
                rotate: [0, -10, 10, -10, 0],
                scale: [1, 1.1, 1, 1.1, 1]
              }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                repeatDelay: 3
              }}
            >
              <Lock size={16} className="text-red-500" />
            </motion.div>
            <span className="font-medium text-gray-700">New</span>
          </div>

          {/* Limit Indicator */}
          <motion.div
            className="absolute -top-1 -right-1 bg-red-500 text-white 
              text-xs px-1.5 py-0.5 rounded-full font-bold
              shadow-sm border border-white"
            initial={{ scale: 0, rotate: -180 }}
            animate={{ scale: 1, rotate: 0 }}
            transition={{ 
              type: "spring", 
              stiffness: 400, 
              damping: 15,
              delay: 0.2 
            }}
          >
            {currentCount}/{maxLimit}
          </motion.div>
        </motion.button>

      </motion.div>
    );
  
};

export default WorkflowLimitButton;